<template>
  <button
    class="custom-button"
    :style="combinedStyles"
    :disabled="disabled"
    @click="buttonAction"
  >
    <span v-if="buttonIcon" :class="buttonIcon"></span>
    {{ buttonText }}
  </button>
</template>

<script>
export default {
  name: 'ButtonComponent',
  props: {
    buttonText: {
      type: String,
      required: true
    },
    buttonColor: {
      type: String,
      default: '#3498db'
    },
    buttonAction: {
      type: Function,
      default: () => {}
    },
    isVisible: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    extraStyles: {
      type: Object,
      default: () => ({})
    },
    buttonIcon: {
      type: String,
      default: ''
    }
  },
  computed: {
    combinedStyles() {
      return {
        '--custom-color': this.buttonColor,
        visibility: this.isVisible ? 'visible' : 'hidden',
        opacity: this.disabled ? 0.5 : 1,
        cursor: this.disabled ? 'not-allowed' : 'pointer',
        ...this.extraStyles 
      };
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-button {
  margin-top: 1px;
  background-color: var(--custom-color);
  color: #ffffff;
  border: none;
  padding: 7px 13px;
  border-radius: 0.375rem;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    filter: brightness(0.85);
  }
}
</style>
